<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="标题">
      <a-input v-model="form.data.title"/>
    </a-form-model-item>
    <a-form-model-item label="副标题">
      <a-input v-model="form.data.subTitle"/>
    </a-form-model-item>
    <a-form-model-item label="封面">
      <div class="a-input">
        <simple-uploader v-model="form.data.coverPath"/>
      </div>
    </a-form-model-item>
    <a-form-model-item label="描述">
      <a-input v-model="form.data.description"/>
    </a-form-model-item>
    <a-form-model-item label="详情页头图">
      <div class="a-input">
        <simple-uploader v-model="form.data.topImagePath"/>
      </div>
    </a-form-model-item>
    <a-form-model-item label="开始售卖时间">
      <a-date-picker
        v-model="form.data.sellStartAt"
        value-format="YYYY-MM-DDTHH:mm:ss"
        :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
        type="datetime"
        placeholder="选择日期时间">
      </a-date-picker>
    </a-form-model-item>
    <a-form-model-item>
      <a-space>
        <a-button type="primary" v-if="!sellPlanId" @click="onAdd">创建</a-button>
        <a-button type="primary" v-if="sellPlanId" @click="onUpdate">更新</a-button>
        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _querySellPlan,
  _addSellPlan,
  _updateSellPlan,
} from '@/api/sellPlanApi';
import SimpleUploader from '@/components/SimpleUploader.vue';
import moment from 'moment';

async function getSellPlan() {
  const result = await _querySellPlan(this.sellPlanId);
  if (result) {
    this.form.data.title = result.title;
    this.form.data.subTitle = result.subTitle;
    this.form.data.coverPath = result.coverPath;
    this.form.data.description = result.description;
    this.form.data.topImagePath = result.topImagePath;
    this.form.data.sellStartAt = result.sellStartAt;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addSellPlan({
        title: this.form.data.title,
        subTitle: this.form.data.subTitle,
        coverPath: this.form.data.coverPath,
        description: this.form.data.description,
        topImagePath: this.form.data.topImagePath,
        sellStartAt: this.form.data.sellStartAt,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('添加成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateSellPlan(this.sellPlanId, {
        title: this.form.data.title,
        subTitle: this.form.data.subTitle,
        coverPath: this.form.data.coverPath,
        description: this.form.data.description,
        topImagePath: this.form.data.topImagePath,
        sellStartAt: this.form.data.sellStartAt,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('更新成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'SellPlanEdit',
  components: { SimpleUploader },
  props: {
    sellPlanId: String,
    day: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    sellPlanId() {
      if (this.sellPlanId) {
        this.getSellPlan();
      }
    },
  },
  methods: {
    moment,
    onAdd,
    onUpdate,
    onCancel,
    getSellPlan,
  },
  data() {
    return {
      form: {
        data: {
          title: '',
          subTitle: '',
          coverPath: '',
          description: '',
          topImagePath: '',
          sellStartAt: `${this.day}T00:00:00`,
        },
        rules: {
          title: [{ required: true, trigger: 'blur' }],
          sellStartAt: [{ required: true, trigger: 'blur' }],
        },
        title: '',
      },
    };
  },
  created() {
    if (this.sellPlanId) {
      this.getSellPlan();
    }
  },
};
</script>
